module.exports = __webpack_public_path__ + "img/4.b1c1b038.jpg";